import './HotListCheckbox.scss';
import Component from './HotListCheckbox.js';
export default Component;
